import { Container } from './Container';
import { Content } from './Content';
import { Text } from './Text';
import { Arrow } from './Arrow';

export default {
  Container,
  Content,
  Text,
  Arrow,
};
